import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async connexionExterieur(connexionForm) {
    let formData = new FormData();
    formData.set("username", connexionForm.email);
    formData.set("password", connexionForm.mdp);
    await axios.post("/api/externe", formData);
  },

  async creationCompte(compteForm) {
    const response = await axios.post("/api/creationCompte", compteForm);
    return response.data;
  },

  async getMDP(formulaire) {
    const response = await axios.post("/api/oubliMdp", formulaire);
    return response.data;
  },

  async changePassword(changePassword) {
    await axios.post("/api/changeMdp", changePassword);
  },

  async checkToken(token) {
    await axios.post("/api/checkToken", token);
  },
};
